function isWeekend(date) {
  return moment(date).format('dddd') == 'Saturday' || moment(date).format('dddd') == 'Sunday'
}

class ProductComponent extends HTMLElement {
  constructor() {
    super()
    this.initialize();
  }

  getBlocks(id, start, end) {
    return fetch(`https://api.bookthatapp.com/v1/blocks?external_id=${id}&start=${start}&finish=${end}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6NjAyMTYsInNob3AiOiJwYWxldHRlLXN1cHBseSJ9.L3-ckRH6wtaJhUwzT4vlfI6K1WnCY2De76M3Bc6mOi0`
      }
    })
      .then(res => res.json())
  }

  setCells() {
    this.cells = document.querySelectorAll('#datepicker td');
    this.cells.forEach((cell, index) => {
      cell.addEventListener('mouseenter', (event) => { this.handleMouseEnter(event, index) })
      cell.addEventListener('mouseleave', this.handleMouseLeave)
    })
  }

  initialize() {
    this.quantity = this.querySelector('[data-product-quantity]');
    this.price = this.querySelector('[data-product-price]');
    this.priceWrapper = this.querySelector('[data-product-price-wrapper]');
    this.dateProperty = this.querySelector('[data-date-property]');
    this.dateStartProperty = this.querySelector('[data-date-start-property]');
    this.dateEndProperty = this.querySelector('[data-date-end-property]');
    this.id = this.getAttribute('data-id');
    this.image = this.querySelector('.product__media--image');
    this.mobileImagesContainer = this.querySelector('[mobile-image-navigation]');
    this.mobileImagePaginationItem = this.querySelectorAll('[mobile-image-navigation-item]');
    this.activeIndex = 0;

    this.mobileImagesContainer && this.mobileImagesContainer.addEventListener('scroll', () => {
      const scroll = this.mobileImagesContainer.scrollLeft;
      const imageWidth = this.mobileImagesContainer.querySelector('.product__media--image').clientWidth;
      const index = Math.floor(scroll / imageWidth);

      if (index !== this.activeIndex && index >= 0) {
        this.activeIndex = index;
        this.mobileImagePaginationItem.forEach((item) => item.classList.remove('active'))
        this.mobileImagePaginationItem[index].classList.add('active')
      }
    }, { passive: true });

    this.mobileImagePaginationItem.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.mobileImagePaginationItem.forEach((item) => item.classList.remove('active'))
        item.classList.add('active')
        const imageWidth = this.image.clientWidth;
        this.mobileImagesContainer.scrollLeft = imageWidth * index;
      }, { passive: true });
    })

    const datepicker = this.querySelector('#datepicker');

    const today = moment(new Date()).utc().subtract(30, 'days').format('YYYY-MM-DD');
    const future = moment(new Date()).utc().add(60, 'days').format('YYYY-MM-DD')

    const isWithingRange = (date) => {
      if (!date || !this.startDate || !this.endDate) return;
      const utcDate = moment(date).utc()
      return utcDate.isBefore(this.endDate) && utcDate.isAfter(this.startDate) || utcDate.isSame(this.startDate) || utcDate.isSame(this.endDate);
    }

    this.getBlocks(this.id, today, future)
      .then(res => {
        let allBlocks = res.blocks;

        $(document).on('product:refresh', () => {
          if (!this.startDate) return;
          this.getBlocks(this.id, this.startDate.subtract(30, 'days').format('YYYY-MM-DD'), this.startDate.add(60, 'days').format('YYYY-MM-DD'))
            .then(res => {
              allBlocks = res.blocks;
              this.startDate = null;
              this.endDate = null;
              $(datepicker).datepicker('refresh')
            })
        });

        this.datepicker = $(datepicker).datepicker({
          defaultDate: null,
          showOn: "both",
          showOtherMonths: true,
          onChangeMonthYear: (year, month) => {
            const newDate = moment(new Date(year, month - 1, 1)).utc();
            this.getBlocks(this.id, newDate.subtract(30, 'days').format('YYYY-MM-DD'), newDate.add(90, 'days').format('YYYY-MM-DD'))
              .then(res => {
                allBlocks = res.blocks
                $(datepicker).datepicker('refresh')
                this.setCells();
              })
          },
          beforeShowDay: (date) => {
            $('.ui-state-hover').removeClass('ui-state-hover')
            const sameDay = allBlocks && allBlocks.find(block => moment.utc(block.date).isSame(moment.utc(date), 'day'));
            const index = allBlocks && allBlocks.findIndex(block => moment.utc(block.date).isSame(moment.utc(date), 'day'))

            if (!sameDay) return [false];

            let isAvailable = false;
            const dateIsWeekend = isWeekend(sameDay.date);
            const dateIsNextTwoDays = moment.utc(sameDay.date).isBefore(moment.utc(new Date()).add(2, 'days'), 'day');

            if ((sameDay && sameDay['available_slot_count'] >= 1 || isWithingRange(date)) && !dateIsWeekend && !dateIsNextTwoDays) {
              isAvailable = true;
            }

            if (index >= 0 && sameDay) {
              const pastDate = allBlocks[index - 5];
              const futureDate = allBlocks[index + 5];
              if (
                futureDate && pastDate &&
                futureDate['available_slot_count'] < 1 &&
                !isWeekend(pastDate.date) &&
                pastDate['available_slot_count'] < 1 &&
                !isWeekend(futureDate.date)
              ) {
                isAvailable = false;
              }
            }

            const isStart = moment.utc(date).isSame(moment.utc(this.startDate))
            const isEnd = moment.utc(date).isSame(moment.utc(this.endDate))

            var activeClass = this.shouldDateBeSelected(date) && isAvailable ? "active" : "";
            var placeClass = isStart ? 'first' : isEnd ? 'last' : '';
            return [isAvailable, `${activeClass} ${placeClass}`];
          },
          minDate: 0
        });

        this.setCells();

        this.datepicker.on('change', function () {
          const date = this.value;
          handleChange(date, allBlocks);
          setTimeout(() => {
            setCells()
          }, 200)
        })
      })
      .catch(e => {
        console.error(e)
      })

    const setCells = this.setCells.bind(this);
    const handleChange = this.handleChange.bind(this);
  }

  handleMouseLeave() {
    $('#datepicker td').removeClass('hover')
    $('#datepicker td').removeClass('hover-first')
    $('#datepicker td').removeClass('hover-last')
    $('#datepicker td').removeClass('ui-state-error')
    $('.product-note').removeClass('error')
  }

  handleMouseEnter(event, index) {
    const day = parseInt($(this.cells[index]).find('.ui-state-default').text());
    const month = $(this.cells[index]).data('month');
    const year = $(this.cells[index]).data('year');

    if ($(this.cells[index]).hasClass('ui-datepicker-week-end')) {
      $(this.cells[index]).addClass('ui-state-error');
      $('.product-note').addClass('error')
    }

    if (!month || !day || !year) return;

    $('#datepicker td').removeClass('hover')
    $('#datepicker td').removeClass('hover-first')
    $('#datepicker td').removeClass('hover-last')

    const getAvailableDaysAfter = () => {
      for (let i = index; i < index + 7; i++) {
        if ($(this.cells[i]).not('.ui-datepicker-week-end').hasClass('ui-datepicker-unselectable')) return i - index - 1;
      }
      return -1;
    }

    const getAvailableDaysBefore = () => {
      for (let i = index; i > index - 7; i--) {
        if ($(this.cells[i]).not('.ui-datepicker-week-end').hasClass('ui-datepicker-unselectable')) return index - i - 1;
      }
      return -1;
    }

    const daysAfter = getAvailableDaysAfter();
    const daysBefore = getAvailableDaysBefore();

    // If no blocking days, set hover
    if (daysBefore == -1 && daysAfter == -1) {
      for (let i = index; i < index + 7; i++) {
        if (i === index) {
          $(this.cells[i]).addClass('hover-first')
        };
        if (i === index + 6) {
          $(this.cells[i]).addClass('hover-last')
        };
        $(this.cells[i]).addClass('hover')
      }
    } else if (daysBefore == -1 && daysAfter == 0) {
      for (let i = index; i >= index - 6; i--) {
        if (i === index - 6) {
          $(this.cells[i]).addClass('hover-first')
        };
        if (i === index) {
          $(this.cells[i]).addClass('hover-last')
        };
        $(this.cells[i]).addClass('hover')
      }
    } else if (daysAfter == -1 && daysBefore == 0) {
      for (let i = index; i <= index + 6; i++) {
        if (i === index) {
          $(this.cells[i]).addClass('hover-first')
        };
        if (i === index + 6) {
          $(this.cells[i]).addClass('hover-last')
        };
        $(this.cells[i]).addClass('hover')
      }
    } else if (daysAfter == -1 && daysBefore > 0) {
      for (let i = index; i >= index; i--) {
        if (i == index) $(this.cells[i]).addClass('hover-first');
        $(this.cells[i]).addClass('hover')
      }

      for (let i = index; i <= index + 6; i++) {
        if (i == index + 6) $(this.cells[i]).addClass('hover-last');
        $(this.cells[i]).addClass('hover')
      }
    } else if (daysBefore == -1 && daysAfter > 0) {
      for (let i = index; i >= index - 6 + daysAfter; i--) {
        if (i == index - 6 + daysAfter) $(this.cells[i]).addClass('hover-first');
        $(this.cells[i]).addClass('hover')
      }

      for (let i = index; i <= index + daysAfter; i++) {
        if (i == index + daysAfter) $(this.cells[i]).addClass('hover-last');
        $(this.cells[i]).addClass('hover')
      }
    } else {
      for (let i = index; i >= index - daysBefore; i--) {
        if (i === index - daysBefore) {
          $(this.cells[i]).addClass('hover-first')
        };
        $(this.cells[i]).addClass('hover')
      }

      for (let i = index; i <= index + daysAfter; i++) {
        if (i === index + daysAfter) {
          $(this.cells[i]).addClass('hover-last')
        };
        $(this.cells[i]).addClass('hover')
      }
    }
  }

  handleChange(date, blocks) {
    const startDate = this.startDate;
    const endDate = this.endDate;
    const index = blocks && blocks.findIndex(block => moment.utc(block.date).isSame(moment.utc(date), 'day'))

    const getAvailableDaysAfter = () => {
      for (let i = index; i < index + 7; i++) {
        if (blocks[i].available_slot_count < 1 && !isWeekend(blocks[i].date)) return i - index - 1;
      }
      return -1;
    }

    const getAvailableDaysBefore = () => {
      for (let i = index; i > index - 7; i--) {
        if (blocks[i].available_slot_count < 1 && !isWeekend(blocks[i].date)) return index - i - 1;
      }
      return -1;
    }


    const daysBefore = getAvailableDaysBefore();
    const daysAfter = getAvailableDaysAfter();

    const setStartAndEnd = (date) => {
      if (daysBefore == -1 && daysAfter >= 0) {
        this.setStartDate(moment(date).subtract(6 - daysAfter, 'days'))
        this.setEndDate(moment(date).add(daysAfter, 'days'));
      } else if (daysAfter == -1 && daysBefore >= 0) {
        this.setStartDate(moment(date));
        this.setEndDate(moment(date).add(6, 'days'));
      } else {
        this.setStartDate(moment(date));
        this.setEndDate(moment(date).add(6, 'days'));
      }
    }

    // If No Date Selected, Set the Dates
    if (!startDate && !endDate) {
      setStartAndEnd(date);
    } else {
      if (
        moment(date).isBefore(moment(endDate).add(6, 'days'))
        && moment(date).isAfter(endDate)
        && (daysAfter == -1 || moment(date).diff(this.endDate, 'days') + daysAfter >= 6)) {
        // Add another week if selected date <= 6 days after end date, is after current end date, and there are available days
        this.setEndDate(moment(endDate).add(7, 'days'))
      } else if (moment(date).isBefore(startDate) || moment(date).isAfter(moment(endDate).add(6, 'days'))) {
        // Reset start and end date if before the current start date or > 6 days after the current end date
        setStartAndEnd(date);
      } else if (moment(date).isAfter(startDate) && moment(date).isBefore(moment(endDate))) {
        //  Reset the start and end date based on selected date
        setStartAndEnd(date);
      }
    }


    this.updateProductForm();
  }

  addZeros(price) {
    let priceParts = price.toString().split('.');
    if (priceParts.length <= 1) return price;
    return price.toFixed(2);
  }

  updateProductForm() {
    const start = this.startDate.utc();
    const end = this.endDate.utc();
    let quantity = 0;
    let dateString = '';

    if (start && !end) {
      quantity = 1;
      dateString = start.format('D MMM, YYYY');
    }

    if (start && end) {
      quantity = Math.abs(start.diff(end, 'days') - 1)
      dateString = `${start.format('D MMM')} - ${end.format('D MMM, YYYY')}`
    }

    this.quantity.value = quantity;

    // SET PRICE
    const price = this.price.getAttribute('data-price');
    this.price.innerHTML = `$${this.addZeros((price / 100) * quantity)}`;
    this.priceWrapper.classList.remove('visually-hidden');
    this.dateProperty.value = dateString;
    this.dateStartProperty.value = start.format('YYYY-MM-D');
    this.dateEndProperty.value = end && end.format('YYYY-MM-D');
  }

  setStartDate(value) {
    this.startDate = value;
  }

  setEndDate(value) {
    this.endDate = value;
  }

  clearEndDate() {
    this.endDate = null;
  }

  clearStartDate() {
    this.startDate = null;
  }

  shouldDateBeSelected(date) {
    var startDate = this.startDate;
    var endDate = this.endDate;
    if (!moment.isMoment(date)) {
      date = moment(date);
    }

    if (startDate && endDate && date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate)) {
      return true;
    } else if (startDate && date.isSame(startDate) || endDate && date.isSame(endDate)) {
      return true;
    } else {
      return false;
    }
  }

  convertStringToJSDate(date, asMoment) {
    asMoment = asMoment || false;
    if (date) {
      var split = date.split("/");
      var day = split[1];
      var month = split[0] - 1;
      var year = split[2];
      if (asMoment) {
        return moment(new Date(year, month, day));
      } else {
        return new Date(year, month, day);
      }
    } else {
      return null;
    }
  }
}

customElements.define('product-component', ProductComponent);